import { Navigate } from "react-router-dom";
import { useAuth } from "@/context/AuthContext";
import { useT } from "@/lib/i18n";

export const ProtectedRoute = ({ children }) => {
  const { user } = useAuth();
  const { t } = useT();
  if (user === null) {
    return (
      <div data-testid="auth-loading" className="min-h-screen flex items-center justify-center font-mono text-xs uppercase tracking-widest text-slate-500">
        {t("loading")}
      </div>
    );
  }
  if (user === false) return <Navigate to="/login" replace />;
  return children;
};
